import {FACTIONS} from "../../../constants/factions";

export const INSECTOIDS_QUOTES = [{
  quote: 'Люди воюют за золото. Мы воюем за мясо. И мясо всегда само приходит к нам строем',
  author: 'Хирин Крепкоспинный, инсектоид-центурион панцирной пехоты',
  factionId: FACTIONS.INSECTOIDS
}, {
  quote: 'Нет необходимости в припасах — нет необходимости в победе. Мы уже победили, пока вы думали, где взять хлеб',
  author: 'Ксирра Шестиногая, главная матка Слепого роя',
  factionId: FACTIONS.INSECTOIDS
}]